module.exports = __webpack_public_path__ + "static/media/clients-page-banner-1.76ec9ad2.jpg";